import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralContainer = styled.div`
  width: 100%;
  height: 96vh;
  background-color: ${({ theme }) => theme.neutral.white};
  .MuiTabs-scroller.MuiTabs-fixed {
    margin-left: 1.5rem;
  }
`;
export const FormContainer = styled.div`
  width: 100%;
  height: 90%;
`;
export const FormField = styled.div`
  margin-left: 1.5rem;
  width: 90%;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  label {
    font-weight: 600;
    font-size: 18px;
    margin: 0 10px;
  }
`;
export const SelectionField = styled.div`
  width: 50%;
  max-width: 455px;
`;
export const FormPreviewContainer = styled.div`
  width: 100%;
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  .choose-form {
    background-color: ${({ theme }) => theme.neutral.white};
  }
  .form-selected {
    padding-top: 20px;
    background-color: ${({ theme }) => theme.neutral.white};
    box-shadow: 0px 0px 10px ${({ theme }) => theme.shadows.strong};
  }
`;
export const PreviewPanel = styled.div`
  width: 80%;
  height: 90%;
  max-width: 1025px;
  max-height: 600px;
  overflow-y: auto;
`;
export const ChooseFormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  label {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    color: ${({ theme }) => theme.neutral.gray[2600]};
    margin-top: 0;
    &:first-of-type {
      margin-top: 24px;
    }
  }
`;

export const ContentModalSaveSurveyAnswer = styled.div`
  position: absolute;
  left: 35.2%;
  right: 35.2%;
  top: 7.64%;
  bottom: 75.77%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  height: fit-content;

  @media only screen and (max-width: 768px) {
    width: 60%;
    left: 20%;
  }
`;

export const ButtonSurveyAnswer = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: white;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
`;
export const TextModalSurveyAnswer = styled.div`
  padding: 1em;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: center;
  svg {
    font-size: xx-large;
  }
`;

export const CloseModalSurveyAnswer = styled.div`
  height: 2em;
  width: 100%;
  text-align: end;
  padding: 0.3em 1em;
  font-weight: 600;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  a {
    color: ${({ theme }) => theme.neutral.black};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const useStyles = makeStyles(() => ({
  delete: {
    color: theme.status.error,
  },
  tabs: {
    backgroundColor: theme.background.light,
  },
}));

export const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    borderColor: "#8F9BB3",
    // You can also use state.isFocused to conditionally style based on the focus state
    "&:hover": {
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgb(0 123 255 / 25%)",
    },
  }),
};
